import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';
import { LoadingScreen } from '@/shared/components/common/LoadingScreen';

export function GuestRoute() {
  const { status } = useAuthStore();

  // Still determining auth status — wait for the full
  // init cycle (including cookie refresh + retries).
  if (status === 'idle' || status === 'loading') {
    return <LoadingScreen />;
  }

  // Already authenticated — redirect to dashboard
  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
